{
	"title": "Attachments",
	"listColumn1": "File Name",
	"listColumn2": "File Size",
	"listColumn3": "Category",
	"listColumn4": "Description",
	"listColumn5": "Updated Date",
	"listColumn6": "Modified By",
	"listColumn7": "Delete",
	"pic": "Image",
	"audio": "Audio",
	"video": "Video",
	"doc": "Document",
	"uploadFile": "Upload",
	"emptyList": "No attachments yet",
	"lackFile": "(File missing)"
}